import React from 'react';
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component

import style from './Details.scss';// to import local scss fle


const Details = props => (
  <div className={cn('row', style.signinSection)}>
    <div className={cn('col s12', style.signinHeader)}>
      <div className={cn('col s12', style.joinUsButtonContainer)}>
        {props.data.page === 'register' ?
          <span>
            <Link to="/">
              <button className={style.notAMember} >
                <spann className={style.loginPageNav}>
                HOME
               </spann>
              </button>
            </Link>
            <button className={style.notAMember}>
              <spann className={style.loginPageNavLight}>
              Already a member?
            </spann>
            </button>
            <Link to="/login">
              <button className={style.detailsHeaderButton}>SIGN IN</button>
            </Link>
          </span>
            :
          <span>
            <Link to="/">
              <button className={style.notAMember}>
                <spann className={style.loginPageNav}>
                HOME
               </spann>
              </button>
            </Link>
            <button className={style.notAMember}>
              <spann className={style.loginPageNavLight}>
              Not a member?
            </spann>
            </button>
            <Link to="/register">
              <button className={style.detailsHeaderButton}>JOIN US</button>
            </Link>
          </span>
          }
      </div>
    </div>
    <div className={cn('col s12', style.signinBody)}>
      <span className={style.signinBodyAlignCenter}>
        <span className={style.detailsHeader}>{props.data.detailsHeader}</span>
        <span className={style.detailsDesc}>{props.data.detailsDesc}</span>
        <div className={style.errorMessageContainer}>
          <Error message={props.errorMessage} />
        </div>
        <div className={style.editableContainer}>
          {props.children}
        </div>
      </span>
    </div>
  </div>
    );

Details.propTypes = {
  data: PropTypes.shape({
    detailsHeader: PropTypes.string,
    detailsDesc: PropTypes.string,
    page: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string,
};

Details.defaultProps = {
  data: {},
  errorMessage: '',
};

export default Details;




// WEBPACK FOOTER //
// ./src/components/Details/Details.js